module.exports = __webpack_public_path__ + "static/media/66.dbdf5eda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/66.svg
// module id = 166
// module chunks = 0